import React, { useEffect, useContext } from "react";
import { useState } from "react";
import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { formatNumber } from "../../services/generalSevices";

export default function Product({ data }) {

    const { currency } = useContext(CurrencyContext);
    const auxCurrency = currency.symbol;

    const [auxPrice, setAuxPrice] = useState(0);

    useEffect(() => {
        getConvertCurrency({ amount: data.price }).then((response) => {
            //setAuxPrice(response[auxCurrency].toFixed(0))
            setAuxPrice(response[auxCurrency].toFixed(2))
        })
    }, [currency])

    return (<div className="product">
        <p className="productName">{data.label}</p>
        <img src={data.image} alt="product" className="productImage" />
        <p className="productPrice">{currency.symbol} {formatNumber(auxPrice)}</p>
    </div>)
}